import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme }) => css`
    &:hover {
      background: #1dbd6b0d;
    }
  `}
`;

export default Wrapper(template);
